import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../Help/AxiosLogicInstance";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import { State, City } from "country-state-city"; // Import the country-state-city package
import { useAuth } from ".././hook/useAuth";
const ObservershipForm = () => {
  const navigate = useNavigate();
  const StudentId = localStorage.getItem("StudentId");
  const [loading, setLoading] = useState(false);
  const isSubmittingRef = useRef(false);
  const [isFormActive, setIsFormActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  // Check if the form is active
  useEffect(() => {
    const checkFormStatus = async () => {
      try {
        const response = await axiosInstance.get('/api/Student/GetApplicationSettingMasterByFormId/4');
        if (response.data && 
            response.data.Status === "200" && 
            response.data.Data && 
            response.data.Data.length > 0) {
          setIsFormActive(response.data.Data[0].IsActive);
        } else {
          setIsFormActive(false);
        }
      } catch (error) {
        console.error("Error fetching form status:", error);
        setIsFormActive(false);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkFormStatus();
  }, [navigate]);
  
  // If form is not active, redirect to observership program page
  useEffect(() => {
    if (!isLoading && !isFormActive) {
      toast.error("Applications are currently closed. Please check back later.");
      navigate('/observership-program');
    }
  }, [isFormActive, isLoading, navigate]);
  
  const [hasSubmitted, setHasSubmitted] = useState(false);
  useEffect(() => {
    document.title = "Observership Application - MedEngage";
  }, []);
  useEffect(() => {
    const loadStatesData = async () => {
      try {
        const response = await fetch('/Districts/states_districts.csv');
        const text = await response.text();
        const lines = text.split('\n').slice(1); // Skip header
        const data = lines.map(line => {
          const [state, district] = line.split(',').map(s => s.replace(/"/g, '').trim());
          return { state, district };
        }).filter(item => item.state && item.district);
        setStatesData(data);
        const uniqueStates = [...new Set(data.map(item => item.state))].sort();
        setIndianStates(uniqueStates);
      } catch (error) {
        console.error('Error loading states data:', error);
      }
    };
    loadStatesData();
  }, []);
  const [submissionData, setSubmissionData] = useState(() => {
    // Get submission data for this specific user
    const submissions = JSON.parse(localStorage.getItem('observershipSubmission') || '{}');
    return submissions[StudentId] || null;
  });
  // Get all Indian states using the country-state-city package
  // const indianStates = State.getStatesOfCountry("IN");
  // State for city/district options based on selected state
  const [cityOptions, setCityOptions] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const [indianStates, setIndianStates] = useState([]);

  const [charCount, setCharCount] = useState({ rationale: 0, benefits: 0 });
  const [collegeFile, setCollegeFile] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [form, setForm] = useState({
    name: "",
    dob: "",
    email: "",
    contact: "",
    institute: "",
    collegeAddress: "",
    courseYear: "",
    qualification: "",
    city: "",
    state: "",
    pincode: "",
    duration: "",
    month: "",
    area: "",
    department: "",
    rationale: "",
    benefits: "",
    hearAbout: "",
    AgreeTerms: false,
    AgreeGuidelines: false,
    desiredlocation: ""
  });
  useEffect(() => {
    if (form.state && statesData.length > 0) {
      const districts = statesData
        .filter(item => item.state === form.state)
        .map(item => item.district)
        .sort();
      setCityOptions(districts);
    } else {
      setCityOptions([]);
    }
  }, [form.state, statesData]);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  // ...existing code...
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "checkbox") {
      setForm({ ...form, [name]: checked });
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    } else if (type === "file") {
      const file = files[0];
      if (!file) {
        setForm({ ...form, [name]: null });
        setErrors((prev) => ({ ...prev, [name]: "Required" }));
        return;
      }
      const validTypes = ["image/jpeg", "image/png"];
      if (!validTypes.includes(file.type)) {
        setForm({ ...form, [name]: null });
        setErrors((prev) => ({ ...prev, [name]: "Only JPG and PNG files are allowed" }));
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        setForm({ ...form, [name]: null });
        setErrors((prev) => ({ ...prev, [name]: "File must be ≤ 10MB" }));
        return;
      }
      setForm({ ...form, [name]: file });
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    } else if (name === "state") {
      // Special handling for state selection
      setForm({
        ...form,
        state: value,
        city: "" // Reset city when state changes
      });
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    } else {
      // For text inputs, allow spaces during typing - trimming will happen on blur
      setForm({ ...form, [name]: value });
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };
  const fieldRefs = {
    name: useRef(),
    dob: useRef(),
    email: useRef(),
    contact: useRef(),
    institute: useRef(),
    collegeFile: useRef(),
    collegeAddress: useRef(),
    qualification: useRef(),
    courseYear: useRef(),
    city: useRef(),
    state: useRef(),
    pincode: useRef(),
    duration: useRef(),
    month: useRef(),
    area: useRef(),
    department: useRef(),
    rationale: useRef(),
    benefits: useRef(),
    hearAbout: useRef(),
    desiredlocation: useRef(),
    signatureFile: useRef(),
    AgreeTerms: useRef(),
    AgreeGuidelines: useRef(),
  };
  const handleTextareaChange = (e) => {
    const { name, value, maxLength } = e.target;
    
    setCharCount((prev) => ({
      ...prev,
      [name]: value.length > maxLength ? maxLength : value.length,
    }));
    
    setForm((prev) => ({ ...prev, [name]: value }));
    
    // Remove error for this textarea as soon as it is filled/changed
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };  

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed !== value) {
        setForm(prev => ({ ...prev, [name]: trimmed }));
       
      }
    }
    setSubmitted(true);
    validate();
  };

  const handleFileChange = (e, setter) => {
    const files = e.target.files;
    const validTypes = [
      "image/jpeg", "image/png", "image/jpg",
      "application/pdf", "application/zip",
      "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];

    // Check all files if multiple
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > 10 * 1024 * 1024) {
        toast.error(`File "${file.name}" must be ≤ 10MB`);
        e.target.value = "";
        setter(null);
        // Remove error for this file field
        const fieldName = setter === setCollegeFile ? "collegeFile" : "signatureFile";
        setErrors((prev) => ({ ...prev, [fieldName]: "File must be ≤ 10MB" }));
        return;
      }
      if (!validTypes.includes(file.type)) {
        toast.error(`Invalid file type for "${file.name}". Only JPG, PNG, PDF, DOC, DOCX, ZIP allowed`);
        e.target.value = "";
        setter(null);
        const fieldName = setter === setCollegeFile ? "collegeFile" : "signatureFile";
        setErrors((prev) => ({ ...prev, [fieldName]: "Invalid file type" }));
        return;
      }
    }

    // If all files are valid, set the file(s)
    if (files.length === 1) {
      setter(files[0]);
    } else {
      setter(files);
    }
    
    // Remove error for this file field as soon as a file is selected
    const fieldName = setter === setCollegeFile ? "collegeFile" : "signatureFile";
    setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
  };
  // ...existing code...
// ...existing code...

// Helper function for leading/trailing space validation
function hasLeadingOrTrailingSpace(str) {
  return typeof str === "string" && str.trim() !== str;
}

const validate = () => {
  const newErrors = {};

  // Field-specific validations first (these should display before generic space errors)
  if (!form.name) newErrors.name = "Required";
  if (form.name && !/^[A-Za-z ]+$/.test(form.name.trim())) {
    newErrors.name = "Only alphabets and spaces allowed";
  }

  if (!form.email) newErrors.email = "Required";
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (form.email && !emailRegex.test(form.email.trim())) {
    newErrors.email = "Invalid email format (e.g., abc@test.com)";
  }

  if (!form.contact) newErrors.contact = "Required";
  const phoneRegex = /^(\+91\s?)?\d{5}\s?\d{5}$/;
  if (form.contact && !phoneRegex.test(form.contact.trim())) {
    newErrors.contact = "Use: +91 91522 11510 or 9152211510";
  }

  if (!form.institute) newErrors.institute = "Required";
  if (form.institute && !/^[A-Za-z .,'()-]+$/.test(form.institute.trim())) {
    newErrors.institute = "Only letters, spaces and . , ' ( ) - allowed";
  }

  if (!form.collegeAddress) newErrors.collegeAddress = "Required";
  const addressRegex = /^[a-zA-Z0-9\s,.\-\/#()]+$/;
  if (form.collegeAddress && !addressRegex.test(form.collegeAddress.trim())) {
    newErrors.collegeAddress = "Address can only contain letters, numbers, spaces, and basic punctuation (,.-/#())";
  }

  if (!form.pincode) newErrors.pincode = "Required";
  if (form.pincode && !/^\d{6}$/.test(form.pincode.trim())) {
    newErrors.pincode = "Pincode should be exactly 6 digits";
  }

  if (!form.desiredlocation) newErrors.desiredlocation = "Required";
  if (form.desiredlocation && !/^[A-Za-z ]+$/.test(form.desiredlocation.trim())) {
    newErrors.desiredlocation = "Only letters and spaces allowed";
  }

  // Date of birth validation to prevent future dates
  if (form.dob) {
    const dobDate = new Date(form.dob);
    const today = new Date();
    if (dobDate > today) {
      newErrors.dob = "Date of birth cannot be in the future";
    }
  }

  // Required field validations
  if (!form.qualification) newErrors.qualification = "Required";
  if (!form.courseYear) newErrors.courseYear = "Required";
  if (!form.city) newErrors.city = "Required";
  if (!form.state) newErrors.state = "Required";
  if (!collegeFile) newErrors.collegeFile = "Required";
  if (!form.duration) newErrors.duration = "Required";
  if (!form.month) newErrors.month = "Required";
  if (!form.area) newErrors.area = "Required";
  if (!form.department) newErrors.department = "Required";
  if (!form.rationale) newErrors.rationale = "Required";
  if (!form.benefits) newErrors.benefits = "Required";
  if (!signatureFile) newErrors.signatureFile = "Required";
  if (!form.hearAbout) newErrors.hearAbout = "Required";

  // Consent validations
  if (!form.AgreeTerms) {
    newErrors.AgreeTerms = "You must confirm this declaration";
  }
  if (!form.AgreeGuidelines) {
    newErrors.AgreeGuidelines = "You must confirm this declaration";
  }

  // Generic space validation (only if no field-specific errors exist for that field)
  const stringFields = [
    "name",
    "email",
    "contact",
    "institute",
    "collegeAddress",
    "qualification",
    "courseYear",
    "city",
    "state",
    "pincode",
    "duration",
    "month",
    "area",
    "department",
    "rationale",
    "benefits",
    "hearAbout",
    "desiredlocation"
  ];

  stringFields.forEach((field) => {
    if (form[field] && hasLeadingOrTrailingSpace(form[field]) && !newErrors[field]) {
     
    }
  });

  setErrors(newErrors);
  return newErrors;
};

// ...existing code...

  // ...existing code...


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    
    // Prevent multiple submissions
    if (loading || isSubmittingRef.current) {
      toast.info("Your form is being processed, please wait...");
      return;
    }
    
    isSubmittingRef.current = true; // Mark as submitting
    
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      // Set loading state to prevent multiple submissions
      setLoading(true);
      
      try {
        // Prepare payload as per API
        let signatureFileBase64 = "";
        let collegeFileBase64 = "";
        
        if (collegeFile) {
          collegeFileBase64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(collegeFile);
          });
        }

        if (signatureFile) {
          signatureFileBase64 = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(signatureFile);
          });
        } else {
          signatureFileBase64 = null; // or "" if your backend expects empty string
        }
        
        // Construct payload
        const payload = {
          Id: 0,
          Name: form.name,
          CollegeName: form.institute,
          State: form.state,
          OtherCollegeName: form.otherCollegeName || "", // Add to form state if needed
          Address: form.collegeAddress,
          Qualification: form.qualification,
          Oqualification: form.oqualification || "", // Add to form state if needed
          TrainingDetails: form.trainingDetails || "", // Add to form state if needed
          Dpt: form.department,
          Duration: form.duration,
          PreferredMonth: form.month,
          AboutProgram: form.benefits,
          Interested: form.hearAbout,
          CreatedAt: new Date().toISOString(),
          UpdatedAt: new Date().toISOString(),
          StudentId: StudentId,
          Email: form.email,
          Contact: form.contact,
          City: form.city,
          Pincode: form.pincode,
          Theme: form.area,
          Rational: form.rationale,
          OtherTheme: form.otherTheme || "", // Add to form state if needed
          Dob: form.dob,
          PreferredTime: form.preferredTime || "", // Add to form state if needed
          CollegeId: collegeFileBase64,
          AreaInterest: form.area,
          SignatureFile: signatureFileBase64,
          AgreeTerms: form.AgreeTerms || false, // Add to form state if needed
          AgreeGuidelines: form.AgreeGuidelines || false, // Add to form state if needed
          CourseYear: form.courseYear,
          DesiredLocation: form.desiredlocation,
          Benefits: form.benefits,
          HearAbout: form.hearAbout
        };
        
        // API call
        const res = await axiosInstance.post(
          "api/Student/ObservershipApplication",
          payload
        );
        
        if (res.data.Status === "200") {
          // Use the reference ID from the API response
          const referenceId = res.data.ReferenceId;
          
          const submissionData = {
            date: new Date().toLocaleDateString(),
            medengageId: referenceId, // Use the server-generated ID
            name: form.name
          };

          const submissions = JSON.parse(localStorage.getItem('observershipSubmission') || '{}');
          submissions[StudentId] = submissionData;
          localStorage.setItem('observershipSubmission', JSON.stringify(submissions));

          toast.success("Submitted successfully");
          navigate("/success", {
            state: {
              referenceId: submissionData.medengageId,
              name: form.name,
              email: form.email,
              formType: "Observership Application"
            },
          });
        }
      } catch (err) {
        toast.error(err.response?.data?.Message || "An error occurred. Please try again.");
      } finally {
        setLoading(false); // End loading state regardless of outcome
        isSubmittingRef.current = false; // Reset submitting state
      }
    } else {
      // Show first error as popup
      const firstErrorField = Object.keys(validationErrors).find((key) => validationErrors[key] && fieldRefs[key]);
      if (firstErrorField && fieldRefs[firstErrorField]?.current) {
        fieldRefs[firstErrorField].current.scrollIntoView({ behavior: "smooth", block: "center" });
        fieldRefs[firstErrorField].current.focus();
      }
      toast.error("Please fill all required fields");
      isSubmittingRef.current = false; // Reset submitting state if validation fails
    }
  };

  return (
    <div className="container-fluid py-5">
      <div className="form-container">
        <h2 className="text-center">
          <span className="green">Observership</span> Application
        </h2>
        <form onSubmit={handleSubmit}>
          <h2 className="section-header">Basic Information</h2>
          <div className="row g-4">
            <div className="col-md-4">
              <label className="form-label">
                Full Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your name"
                name="name"
                value={form.name}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.name}
              />
              {submitted && errors.name && (
                <div className="text-danger small">{errors.name}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">Date of Birth</label>
              <input
                type="date"
                className="form-control"
                name="dob"
                onBlur={() => {
                  setSubmitted(true);
                  validate();
                }}
                value={form.dob}
                onChange={handleChange}
                ref={fieldRefs.dob}
              />
              {submitted && errors.dob && (
                <div className="text-danger small">{errors.dob}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Email Address <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                name="email"
                onBlur={handleBlur}
                value={form.email}
                onChange={handleChange}
                ref={fieldRefs.email}
              />
              {submitted && errors.email && (
                <div className="text-danger small">{errors.email}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Contact Number <span className="text-danger">*</span>
              </label>
              <input
                type="tel"
                className="form-control"
                placeholder="Enter your phone"
                name="contact"
                value={form.contact}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.contact}
              />
              {submitted && errors.contact && (
                <div className="text-danger small">{errors.contact}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Name Of College/Institute/Organisation{" "}
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Name of college/institute"
                name="institute"
                value={form.institute}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.institute}
              />
              {submitted && errors.institute && (
                <div className="text-danger small">{errors.institute}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Upload College ID
                <span className="small text-muted">
                  (Accepted formats: .jpg, .png. Max size: 10 MB){" "}
                </span>
                <span className="text-danger">*</span>
              </label>

              <div className="file-upload-wrapper">
                <label className="file-upload-btn">
                  {collegeFile ? collegeFile.name : "Choose File"}
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => handleFileChange(e, setCollegeFile)}
                    ref={fieldRefs.collegeFile}
                  />
                </label>
                {/* Show selected file name if file is chosen */}
                {collegeFile && (
                  <div className="mt-1 text-success">
                    Selected file: {collegeFile.name}
                  </div>
                )}
                {submitted && errors.collegeFile && (
                  <small className="text-danger d-block">
                    {errors.collegeFile}
                  </small>
                )}
              </div>
            </div>
            <div className="col-md-4">
              <label className="form-label">
                College Address <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your College address"
                name="collegeAddress"
                value={form.collegeAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.collegeAddress}
              />
              {submitted && errors.collegeAddress && (
                <div className="text-danger small">{errors.collegeAddress}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Qualification <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="qualification"
                value={form.qualification}
                onChange={handleChange}
                ref={fieldRefs.qualification}
              >
                <option value="">Select Qualification</option>
                <option value="mbbs">MBBS</option>
                <option value="bds">BDS</option>
                <option value="md">MD</option>
                <option value="ms">MS</option>
                <option value="phd">PhD</option>
                <option value="other">Other</option>
              </select>
              {submitted && errors.qualification && (
                <div className="text-danger small">{errors.qualification}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Course Year <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="courseYear"
                value={form.courseYear}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.courseYear}
              >
                <option value="">Select your course year</option>
                <option value="1st Year MBBS">1st Year MBBS</option>
                <option value="2nd Year MBBS">2nd Year MBBS</option>
                <option value="3rd Year MBBS">3rd Year MBBS</option>
                <option value="4th Year MBBS">4th Year MBBS</option>
                <option value="Internships">Internships</option>
                <option value="PGs (MD/MS and DNB)">PGs (MD/MS and DNB)</option>
              </select>
              {submitted && errors.courseYear && (
                <small className="text-danger">{errors.courseYear}</small>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label">
                State <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="state"
                value={form.state}
                onChange={handleChange}
                ref={fieldRefs.state}
              >
                <option value="">Select State</option>
                {indianStates.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
              {submitted && errors.state && (
                <div className="text-danger small">{errors.state}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                City <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="city"
                value={form.city}
                onChange={handleChange}
                ref={fieldRefs.city}
                placeholder="Enter city"
              />
              {submitted && errors.city && (
                <div className="text-danger small">{errors.city}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Pincode <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your pincode"
                name="pincode"
                value={form.pincode}
                maxLength={6}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.pincode}
              />
              {submitted && errors.pincode && (
                <div className="text-danger small">{errors.pincode}</div>
              )}
            </div>
          </div>
          <h2 className="section-header">Observership Programme Details</h2>
          <div className="row g-4">
            <div className="col-md-4">
              <label className="form-label">
                Duration Of Observership <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="duration"
                value={form.duration}
                onChange={handleChange}
                ref={fieldRefs.duration}
              >
                <option value="">Enter duration</option>
                <option value="1-week">1 Week</option>
                <option value="2-weeks">2 Weeks</option>
                <option value="1-month">1 Month</option>
                <option value="2-months">2 Months</option>
                <option value="3-months">3 Months</option>
              </select>
              {submitted && errors.duration && (
                <div className="text-danger small">{errors.duration}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Preferred Month <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="month"
                value={form.month}
                onChange={handleChange}
                ref={fieldRefs.month}
              >
                <option value="">Select Month</option>
                <option value="january">January</option>
                <option value="february">February</option>
                <option value="march">March</option>
                <option value="april">April</option>
                <option value="may">May</option>
                <option value="june">June</option>
                <option value="july">July</option>
                <option value="august">August</option>
                <option value="september">September</option>
                <option value="october">October</option>
                <option value="november">November</option>
                <option value="december">December</option>
              </select>
              {submitted && errors.month && (
                <div className="text-danger small">{errors.month}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Area Of Interest <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="area"
                value={form.area}
                onChange={handleChange}
                ref={fieldRefs.area}
              >
                <option value="">Select your area of interest</option>
                <option value="cardiology">Cardiology</option>
                <option value="neurology">Neurology</option>
                <option value="oncology">Oncology</option>
                <option value="pediatrics">Pediatrics</option>
                <option value="surgery">Surgery</option>
                <option value="orthopedics">Orthopedics</option>
                <option value="radiology">Radiology</option>
                <option value="pathology">Pathology</option>
              </select>
              {submitted && errors.area && (
                <div className="text-danger small">{errors.area}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Choose A Theme / Dept Of Lab Medicine For Observership Programme{" "}
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="department"
                value={form.department}
                onChange={handleChange}
                ref={fieldRefs.department}
              >
                <option value="">Select From Dropdown</option>
                <option value="internal-medicine">Internal Medicine</option>
                <option value="emergency">Emergency Medicine</option>
                <option value="icu">Critical Care</option>
                <option value="psychiatry">Psychiatry</option>
                <option value="dermatology">Dermatology</option>
                <option value="ophthalmology">Ophthalmology</option>
                <option value="ent">ENT</option>
                <option value="gynecology">Gynecology</option>
              </select>
              {submitted && errors.department && (
                <div className="text-danger small">{errors.department}</div>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label">
                Where And How Did You Hear About Observership Programme?{" "}
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="hearAbout"
                value={form.hearAbout}
                onChange={handleChange}
                ref={fieldRefs.hearAbout}
              >
                <option value="">Select your option</option>
                <option value="website">Website</option>
                <option value="social-media">Social Media</option>
                <option value="college">College</option>
                <option value="friend">Friend</option>
                <option value="other">Other</option>
              </select>
              {submitted && errors.hearAbout && (
                <div className="text-danger small">{errors.hearAbout}</div>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label">
                College Address <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your College address"
                name="collegeAddress"
                value={form.collegeAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.collegeAddress}
              />
              {submitted && errors.collegeAddress && (
                <div className="text-danger small">{errors.collegeAddress}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Qualification <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="qualification"
                value={form.qualification}
                onChange={handleChange}
                ref={fieldRefs.qualification}
              >
                <option value="">Select Qualification</option>
                <option value="mbbs">MBBS</option>
                <option value="bds">BDS</option>
                <option value="md">MD</option>
                <option value="ms">MS</option>
                <option value="phd">PhD</option>
                <option value="other">Other</option>
              </select>
              {submitted && errors.qualification && (
                <div className="text-danger small">{errors.qualification}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Course Year <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your course Year"
                name="courseYear"
                value={form.courseYear}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.courseYear}
              />
              {submitted && errors.courseYear && (
                <div className="text-danger small">{errors.courseYear}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                City <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="city"
                value={form.city}
                onChange={handleChange}
                ref={fieldRefs.city}
                placeholder="Enter city"
              />
              {submitted && errors.city && (
                <div className="text-danger small">{errors.city}</div>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label d-flex justify-content-between align-items-center">
                <span>
                  MHL Laboratory location Where Observership is Desired
                  <span className="text-danger ms-1">*</span>
                </span>
                <a
                  href="https://www.metropolisindia.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-success"
                >
                  (Please visit Metropolis India)
                </a>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your Location"
                name="desiredlocation"
                value={form.desiredlocation}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.desiredlocation}
              />
              {submitted && errors.desiredlocation && (
                <div className="text-danger small">
                  {errors.desiredlocation}
                </div>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label">
                Digital Signature Upload
                <span className="small text-muted">
                  (Accepted formats: .jpg, .png, .jpeg, .pdf Max 10 MB){" "}
                </span>
                <span className="text-danger">*</span>
              </label>

              <div className="file-upload-wrapper">
                <label className="file-upload-btn">
                  {signatureFile ? signatureFile.name : "Choose File"}
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png,.pdf"
                    onChange={(e) => handleFileChange(e, setSignatureFile)}
                    ref={fieldRefs.signatureFile}
                  />
                </label>
                {/* Show selected file name if file is chosen */}
                {signatureFile && (
                  <div className="mt-1 text-success">
                    Selected file: {signatureFile.name}
                  </div>
                )}
                {submitted && errors.signatureFile && (
                  <small className="text-danger d-block">
                    {errors.signatureFile}
                  </small>
                )}
              </div>
            </div>
            <div className="col-12">
              <label className="form-label">
                In 100 Words Share Your Rationale For Your Observership
                Programme <span className="text-danger">*</span>
              </label>
              <textarea
                name="rationale"
                className="form-control"
                rows="4"
                placeholder="Enter your answer"
                maxLength={500}
                value={form.rationale}
                onChange={handleTextareaChange}
                onBlur={handleBlur}
                ref={fieldRefs.rationale}
              ></textarea>
              <span className="char-counter">{charCount.rationale}/500</span>
              {submitted && errors.rationale && (
                <div className="text-danger small">{errors.rationale}</div>
              )}

              <div className="col-12">
                <label className="form-label">
                  How Will This Observership Programme Help You In Your Career
                  As Health Care Professional{" "}
                  <span className="text-danger">*</span>
                </label>
                <textarea
                  name="benefits"
                  className="form-control"
                  rows="4"
                  placeholder="Enter your answer"
                  maxLength={500}
                  value={form.benefits}
                  onChange={handleTextareaChange}
                  onBlur={handleBlur}
                  ref={fieldRefs.benefits}
                ></textarea>

                <span className="char-counter">{charCount.benefits}/500</span>
                {submitted && errors.benefits && (
                  <div className="text-danger small">{errors.benefits}</div>
                )}
              </div>
            </div>

            <div className="col-12 mt-4">
              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="AgreeTerms"
                  name="AgreeTerms"
                  checked={form.AgreeTerms}
                  onChange={handleChange}
                  ref={fieldRefs.AgreeTerms}
                />
                <label className="form-check-label" htmlFor="AgreeTerms">
                  I confirm that all details provided in this application form
                  are true to the best of my knowledge.{" "}
                  <span className="text-danger">*</span>
                </label>
                {submitted && errors.AgreeTerms && (
                  <div className="text-danger small">{errors.AgreeTerms}</div>
                )}
              </div>
              <div className="form-check mb-4">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="AgreeGuidelines"
                  name="AgreeGuidelines"
                  checked={form.AgreeGuidelines}
                  onChange={handleChange}
                  ref={fieldRefs.AgreeGuidelines}
                />
                <label className="form-check-label" htmlFor="AgreeGuidelines">
                  <i className="fa fa-signature me-2"></i>My signature is
                  attached, and I adhere to the above declarations.{" "}
                  <span className="text-danger">*</span>
                </label>
                {submitted && errors.AgreeGuidelines && (
                  <div className="text-danger small">
                    {errors.AgreeGuidelines}
                  </div>
                )}
              </div>
            </div>
            <div
              class="alert alert-info d-flex align-items-center"
              role="alert"
            >
              <i class="fa fa-sticky-note me-2" aria-hidden="true"></i>
              <strong>Note:</strong> Please review the form carefully before
              submitting.
            </div>
            <div className="text-center mt-5">
              <button
                type="submit"
                className="btn btn-outline-success rounded-3 submit-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  <>
                    <i className="fa fa-paper-plane me-2"></i>Submit Application
                  </>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ObservershipForm;

